"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var FieldValidationErrors = function (props) {
  if (props.fieldValidationErrorsComponent) {
    var CustomError = props.fieldValidationErrorsComponent;
    // strip the errors component from the custom component props
    // (prevents infinite loop rendering if someone reuses this component as a custom error component)
    var fieldValidationErrorsComponent = props.fieldValidationErrorsComponent,
      errorsComponentProps = __rest(props, ["fieldValidationErrorsComponent"]);
    return react_1.default.createElement(CustomError, __assign({}, errorsComponentProps));
  }
  var errors = props.errors;
  if (!errors || errors.length === 0) {
    return null;
  }
  return react_1.default.createElement("div", {
    className: "invalid"
  }, errors.map(function (error, index) {
    return react_1.default.createElement("p", {
      key: index
    }, error);
  }));
};
exports.FieldValidationErrors = FieldValidationErrors;